import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2, Crown } from "lucide-react";
import PublicHeader, { Footer } from "@/components/PublicHeader";
import PricingCards from "@/components/PricingCards";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function Pricing() {
  return (
    <div className="min-h-screen" data-testid="pricing-page">
      <PublicHeader />
      <main className="max-w-4xl mx-auto px-5 md:px-10 pt-8 fade-up">
        <p className="eyebrow mb-3">Pricing</p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl mb-4">Choose her plan.</h1>
        <p className="muted text-sm mb-12">Have the code CERTIFIED30? Enter it below for 30 days of Pro, free.</p>
        <PricingCards />
      </main>
      <Footer />
    </div>
  );
}

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const [state, setState] = useState("checking");

  useEffect(() => {
    const sid = params.get("session_id");
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { await refresh(); setState("paid"); return; }
      } catch { /* keep polling */ }
      if (++tries >= 15) return setState("timeout");
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [params, refresh]);

  return (
    <div className="min-h-screen flex flex-col">
      <PublicHeader />
      <main className="flex-1 flex items-center justify-center px-5">
        <div className="panel p-10 text-center max-w-md w-full fade-up" data-testid="payment-success-panel">
          {state === "checking" && (<><Loader2 className="animate-spin text-[#9C4DDC] mx-auto mb-4" /><p className="font-display text-2xl">Confirming your payment…</p></>)}
          {state === "paid" && (<>
            <Crown className="text-[#9C4DDC] mx-auto mb-4" strokeWidth={1.25} size={36} />
            <h1 className="font-display text-3xl accent-text" data-testid="payment-success-title">Welcome to Pro</h1>
            <p className="muted text-sm mt-3">3 muses, unlimited posts and the Weekly Planner are unlocked.</p>
            <Link to="/planner" className="btn-primary w-full mt-8" data-testid="payment-success-planner-button">Plan my week</Link>
          </>)}
          {state === "timeout" && (<><p className="font-display text-2xl">Still processing</p><p className="muted text-sm mt-2">Your payment is taking longer than usual. Check your Account page in a minute.</p>
            <Link to="/account" className="btn-secondary w-full mt-6">Go to account</Link></>)}
        </div>
      </main>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="min-h-screen flex flex-col">
      <PublicHeader />
      <main className="flex-1 flex items-center justify-center px-5">
        <div className="panel p-10 text-center max-w-md w-full" data-testid="payment-cancel-panel">
          <p className="font-display text-2xl">Checkout cancelled</p>
          <p className="muted text-sm mt-2">No charge was made.</p>
          <Link to="/pricing" className="btn-secondary w-full mt-6" data-testid="payment-cancel-back-button">Back to pricing</Link>
        </div>
      </main>
    </div>
  );
}
